import { render } from "./AiDestinationSuggestView.vue?vue&type=template&id=699fea11&scoped=true"
import script from "./AiDestinationSuggestView.vue?vue&type=script&lang=js"
export * from "./AiDestinationSuggestView.vue?vue&type=script&lang=js"

import "./AiDestinationSuggestView.vue?vue&type=style&index=0&id=699fea11&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-699fea11"]])

export default __exports__